import React, { useState } from 'react';
import Joi from 'joi';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  showSuccess,
  showError,
  getErrorByName,
  getTranslate,
} from '../../../../Helper';
import { LOGIN } from '../../../../store/login/Actions';
import { Inputs } from '../../../../Components';
import { ApplicationUserResetPassword } from '../../../../Services/LoginService';
import {
  atLeastOneNumber,
  charactersLength,
  containUpper,
  containSpecialCharacter,
} from '../../../../Utils/Expressions';
import { LOGOUt } from '../../../../store/login/Actions';
import propxLogin from '../../../../assets/images/pages/login/propx-login.svg';
import { LoginFormsEnum } from './LoginFormsEnum';
import { ArrowLeftIcon, CheckCircleIcon } from '../../../../assets/icons';

export const ChangePasswordForm = ({
  setActiveLoginForm,
  userVerificationInfo,
  translationPath,
  parentTranslationPath,
  isPasswordExpired,
  loginDto,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const dispatch = useDispatch(LOGIN);

  const [newPasswords, setNewPasswords] = useState({
    ViewNewassword: '',
    ViewconfirmPassword: '',
  });
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const schema = Joi.object({
    newPassword: Joi.string()
      .required()
      .regex(atLeastOneNumber)
      .regex(containSpecialCharacter)
      .regex(containUpper)
      .regex(charactersLength)
      .messages({
        'string.empty': t(`${translationPath}password-is-required`),
        'string.pattern.base': t(`${translationPath}weak-password`),
      }),
    confirmPassword: Joi.string()
      .valid(Joi.ref('newPassword'))
      .required()
      .messages({
        'any.only': t(`${translationPath}password-not-matched`),
        'string.empty': t(`${translationPath}confirm-password-is-required`),
      }),
  })
    .options({
      abortEarly: false,
    })
    .validate({ newPassword, confirmPassword });
  const handleResetPassword = async (event) => {
    event.preventDefault();
    if (schema.error) {
      showError(getTranslate()('shared.please-fix-all-errors'));
      return;
    }
    const res = await ApplicationUserResetPassword({
      identityVerificationId: +userVerificationInfo.identityVerificationId,
      newPassword,
    });
    if (!(res && res.status && res.status !== 200)) {
      localStorage.removeItem('session');
      dispatch(LOGOUt());
      setActiveLoginForm(LoginFormsEnum.SignIn.key);
      showSuccess(t(`${translationPath}change-password-Succssfuly`));
    } else showError(t(`${translationPath}failed-change-password`));
  };

  return (
    <div className='login-form-container'>
      <div className='login-header'>
        <img src={propxLogin} />
      </div>
      <h1 className='heading-1'>{t(`${translationPath}Change-Password`)}</h1>
      <div className='login-form'>
        <form
          noValidate
          className='form-wrapper'
          onSubmit={handleResetPassword}
        >
          <div className='form-first-input'>
            <Inputs
              idRef='newPassword'
              fieldClasses='fields-content'
              type={!newPasswords.ViewNewassword ? 'password' : ''}
              labelValue={t(`${translationPath}new-password`)}
              inputPlaceholder={t(`${translationPath}new-password`)}
              helperText={getErrorByName(schema, 'newPassword').message}
              error={getErrorByName(schema, 'newPassword').error}
              isWithError
              value={newPassword}
              endAdornment={
                <Button
                  onClick={() => {
                    setNewPasswords({
                      ...newPasswords,
                      ViewNewassword: !newPasswords.ViewNewassword,
                    });
                  }}
                  className='p-2'
                >
                  {newPasswords.ViewNewassword ? (
                    <span className='mdi mdi-eye-outline' />
                  ) : (
                    <span className='mdi mdi-eye-off-outline' />
                  )}
                </Button>
              }
              onInputChanged={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className='form-second-input'>
            <Inputs
              idRef='confirmPassword'
              fieldClasses='fields-content'
              type={!newPasswords.ViewconfirmPassword ? 'password' : ''}
              labelValue={t(`${translationPath}confirmPassword`)}
              inputPlaceholder={t(`${translationPath}confirmPassword`)}
              helperText={getErrorByName(schema, 'confirmPassword').message}
              error={getErrorByName(schema, 'confirmPassword').error}
              isWithError
              value={confirmPassword}
              endAdornment={
                <Button
                  onClick={() => {
                    setNewPasswords({
                      ...newPasswords,
                      ViewconfirmPassword: !newPasswords.ViewconfirmPassword,
                    });
                  }}
                  className='p-2'
                >
                  {newPasswords.ViewconfirmPassword ? (
                    <span className='mdi mdi-eye-outline' />
                  ) : (
                    <span className='mdi mdi-eye-off-outline' />
                  )}
                </Button>
              }
              onInputChanged={(e) => {
                setConfirmPassword(e.target.value);
              }}
            />
          </div>
          <div className='password-validation-wrapper'>
            <span className='checkText'>
              <CheckCircleIcon
                width='20'
                height='20'
                viewBox='0 0 20 21'
                fill={
                  atLeastOneNumber.test(newPassword) ? '#7F6944' : '#D0D5DD'
                }
              />
              <span
                className={
                  atLeastOneNumber.test(newPassword)
                    ? 'checkText-info-selected'
                    : 'checkText-info'
                }
              >
                {'Must be at least 1 number'}
              </span>
            </span>
            <span className='checkText'>
              <CheckCircleIcon
                width='20'
                height='20'
                viewBox='0 0 20 21'
                fill={
                  charactersLength.test(newPassword) ? '#7F6944' : '#D0D5DD'
                }
              />
              <span
                className={
                  charactersLength.test(newPassword)
                    ? 'checkText-info-selected'
                    : 'checkText-info'
                }
              >
                {'Must be between 8-20 characters'}
              </span>
            </span>

            <span className='checkText'>
              <CheckCircleIcon
                width='20'
                height='20'
                viewBox='0 0 20 21'
                fill={containUpper.test(newPassword) ? '#7F6944' : '#D0D5DD'}
              />
              <span
                className={
                  containUpper.test(newPassword)
                    ? 'checkText-info-selected'
                    : 'checkText-info'
                }
              >
                {'Must be at least 1 uppercase letter'}
              </span>
            </span>

            <span className='checkText'>
              <CheckCircleIcon
                width='20'
                height='20'
                viewBox='0 0 20 21'
                fill={
                  containSpecialCharacter.test(newPassword)
                    ? '#7F6944'
                    : '#D0D5DD'
                }
              />
              <span
                className={
                  containSpecialCharacter.test(newPassword)
                    ? 'checkText-info-selected'
                    : 'checkText-info'
                }
              >
                {'Must contain one special character(!@#$%^&*)'}
              </span>
            </span>
          </div>
          <div className='d-flex-column-center'>
            <Button
              className='login-btn'
              type='submit'
            >
              {<span>{t(`${translationPath}change-password`)}</span>}
            </Button>
          </div>
          <div
            className='back-to-login'
            onClick={() => setActiveLoginForm(LoginFormsEnum.SignIn.key)}
          >
            <ArrowLeftIcon
              width={20}
              height={20}
              fill={'#475467'}
              className='back-to-login-icon'
            />
            <span className='back-to-login-text'>
              {t(`${translationPath}back-to-login`)}
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};
